import { initialReferralState, ReferralActionTypes, SetRenewalDateResponse } from '../types';
import createAsyncMapReducer from '~lib/shared/redux/reducers/async-map-reducer';

const setRenewalDate = createAsyncMapReducer<SetRenewalDateResponse>(
	ReferralActionTypes.SET_RENEWAL_DATE,
	initialReferralState.setRenewalDate
);

export default setRenewalDate;
